(() => {
  if (window.tshBrandsDirectory) {
    window.tshBrandsDirectory(document);
    return;
  }
  const bind = root => {
    if (root.dataset.brandsReady) return;
    root.dataset.brandsReady = 'true';
    const cards = [...root.querySelectorAll('[data-brand-name]')];
    const input = root.querySelector('[data-brand-search]');
    const count = root.querySelector('[data-brand-count]');
    const clear = root.querySelector('[data-brand-clear]');
    const empty = root.querySelector('[data-brand-empty]');
    const index = root.querySelector('[data-brand-index]');
    const normal = s => String(s).toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    root.querySelectorAll('[data-brand-jump]').forEach(a => {
      a.hidden = !cards.some(c => c.dataset.brandGroupKey === a.dataset.brandJump);
    });
    const update = () => {
      const term = normal(input?.value.trim() || '');
      let visible = 0;
      cards.forEach(card => {
        card.hidden = !normal(card.dataset.brandName).includes(term);
        if (!card.hidden) visible++;
      });
      if (index) index.hidden = !!term;
      if (clear) clear.hidden = !term;
      if (empty) empty.hidden = !!visible;
      count.textContent = (term ? root.dataset.filteredTemplate : root.dataset.countTemplate)
        .replaceAll('[count]', String(cards.length)).replaceAll('[visible]', String(visible));
    };
    const reset = focus => {
      if (input) input.value = '';
      update();
      if (focus) input?.focus();
    };
    if (input) {
      root.querySelector('.br-search').hidden = false;
      input.addEventListener('input', update);
      input.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); reset(true); }
      });
      clear?.addEventListener('click', () => reset(true));
    }
    root.querySelector('[data-brand-reset]')?.addEventListener('click', () => reset(true));
    root.addEventListener('shopify:block:select', e => {
      reset(false);
      e.target.closest('.br-card')?.scrollIntoView({block:'center',behavior:'instant'});
    });
    update();
  };
  const mount = scope => {
    if (scope.matches?.('[data-brand-directory]')) bind(scope);
    scope.querySelectorAll('[data-brand-directory]').forEach(bind);
  };
  window.tshBrandsDirectory = mount;
  mount(document);
  document.addEventListener('shopify:section:load', e => mount(e.target));
})();
